<nav class="navbar navbar-expand-lg" style="background: linear-gradient(to right, #1F6F8B, #0F2A44); color: #ffffff;">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/" [title]="buildNumber() ? 'Build Number: ' + buildNumber() : ''" style="color: #ffffff;">Property MDM</a>
    @if (!isLoginPage()) {
      <button
        class="navbar-toggler"
        type="button"
        aria-label="Toggle navigation"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        [attr.aria-expanded]="expanded()"
        (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
    }

    <div class="collapse navbar-collapse"
         id="navbarSupportedContent"
         [class.show]="expanded() && !isLoginPage()"
         (click)="collapse()"
         (keyup.enter)="collapse()"
         (keyup.space)="collapse()"
         tabindex="0"
         role="button">

      @if (!isLoginPage()) {
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a class="nav-link" routerLink="/dashboard" routerLinkActive="active">Dashboard</a>
          </li>
 <!-- <li class="nav-item">
            <a class="nav-link" routerLink="/suspected-matches" routerLinkActive="active">Suspected Matches</a>
          </li> -->

          <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
          <li class="nav-item dropdown"
              [class.show]="dropdownOpen()"
              (document:click)="closeDropdown()"
              (document:keyup.escape)="closeDropdown()"
              routerLinkActive="active">
            <a class="nav-link dropdown-toggle"
               id="navbarDropdownMenuLink"
               href="#"
               role="button"
               aria-haspopup="true"
               [attr.aria-expanded]="dropdownOpen()"
               (click)="toggleDropdown($event)"
               (keyup.enter)="toggleDropdown($event)"
               (keyup.space)="toggleDropdown($event)"
               tabindex="0">
              Admin
            </a>
            @if (dropdownOpen()) {
              <div class="dropdown-menu show" aria-labelledby="navbarDropdownMenuLink">
                @if (features.createPortfolio) {
                  <a class="dropdown-item" routerLink="/create-portfolio" routerLinkActive="active">Create Portfolio</a>
                }
                <a class="dropdown-item" routerLink="/batch-history" routerLinkActive="active">Batch History</a>
                @if (features.bulkUpload) {
                  <a class="dropdown-item" routerLink="/property-csv-uploads" routerLinkActive="active">Bulk Property Uploads</a>
                }
                <a class="dropdown-item" routerLink="/source-property-auto-match-manager" routerLinkActive="active">Source Property Matching</a>
                @if (isSuperAdmin()) {
                  <a class="dropdown-item" routerLink="/property-change-log" routerLinkActive="active">Property Change Log</a>
                  <a class="dropdown-item" routerLink="/user-roles" routerLinkActive="active">User Roles</a>
                  <a class="dropdown-item" routerLink="/user-access-log" routerLinkActive="active">User Access Log</a>
                }
              </div>
            }
          </li>

          <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
          <li class="nav-item dropdown"
              [class.show]="reportsDropdownOpen()"
              (document:click)="closeDropdown()"
              (document:keyup.escape)="closeDropdown()"
              routerLinkActive="active">
            <a class="nav-link dropdown-toggle"
               id="reportsDropdownMenuLink"
               href="#"
               role="button"
               aria-haspopup="true"
               [attr.aria-expanded]="reportsDropdownOpen()"
               (click)="toggleReportsDropdown($event)"
               (keyup.enter)="toggleReportsDropdown($event)"
               (keyup.space)="toggleReportsDropdown($event)"
               tabindex="0">
              Reports
            </a>
            @if (reportsDropdownOpen()) {
              <div class="dropdown-menu show" aria-labelledby="reportsDropdownMenuLink">
                <a class="dropdown-item" routerLink="/triana-property-audit" routerLinkActive="active">Triana Property Audit</a>
                <a class="dropdown-item" routerLink="/no-address-properties" routerLinkActive="active">Unresolved Properties</a>
                <a class="dropdown-item" routerLink="/unmastered-properties" routerLinkActive="active">Unmastered Properties</a>
              </div>
            }
          </li>
        </ul>
        <!-- navbar-actions carries mobile-only rules; it has no desktop styles, so the web
             layout is byte-for-byte what it was. -->
        <div class="d-flex align-items-center navbar-actions" style="gap: 1rem;">
          <!-- The group selection is global state that every screen depends on, so it lives in
               global chrome rather than being repeated in each page header. -->
          <div class="navbar-portfolio">
            <app-portfolio-selector
              [initialPortfolio]="currentPortfolio()"
              [clearTrigger]="selectorClearTrigger()"
              (selectionChange)="onPortfolioSelected($event)"
              (cleared)="onPortfolioCleared()"></app-portfolio-selector>
          </div>

          <div class="d-flex" id="userprofile">
            <app-userprofile></app-userprofile>
          </div>
        </div>
      }

    </div>
  </div>
  
</nav>
